import React, {Component} from 'react';
import Date from 'apa/components/Date';
import {ButtonGroup} from 'reactstrap';

export const TYPE_CHOICES = [
    'Bank',
    'Kassenbuch',
    'Sonstiges'
];

export const CLASS_CHOICES = [
    'Keine Angabe',
    'Ausgabe',
    'Einnahme',
    'Übertrag',
    'Einzahlung',
];

export const TAX_CHOICES = [
    'Keine Angabe',
    '0 %',
    '19 %',
    '7 %',
    '16 %',
    '5 %',
];

export default class Item extends Component {
    render() {
        const item = this.props.item;
        return (
            <tr>
                <td>
                    <Date date={item.date}/>
                </td>
                <td>
                    {item.description}
                </td>
                <td>
                    {TYPE_CHOICES[item.type]}
                </td>
                <td>
                    {CLASS_CHOICES[item.class_type]}
                </td>
                <td>
                    {item.amount}
                </td>
                <td>
                    {TAX_CHOICES[item.tax_type]}
                </td>
                <td>
                    <ButtonGroup>
                    </ButtonGroup>
                </td>
            </tr>
        )
    }
}
